module.exports = __webpack_public_path__ + "img/item4.f20ea0fa.png";